<!-- TableView.vue -->
<template>
  <div v-if="tableData?.table" class="table-container">
    <table class="custom-table">
      <thead>
      <tr>
        <th v-for="(header, index) in tableData.table.column_names"
            :key="index"
            class="table-header">
          {{ cleanHeaderName(header) }}
        </th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(row, rowIndex) in tableData.table.rows"
          :key="rowIndex"
          class="table-row">
        <td v-for="(cell, cellIndex) in row"
            :key="cellIndex"
            class="table-cell"
            :style="getColumnStyle(cell)">
          {{ cell }}
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';

defineProps({
  tableData: {
    type: Object,
    default: () => ({})
  }
});

const cleanHeaderName = (header) => {
  // Remove data type information in parentheses
  return header.replace(/\s*\([^)]*\)$/, '');
};

const getColumnStyle = (content) => {
  // Dynamically calculate width based on content type
  content = String(content)
  if (content) {
    if (content.includes('@')) {
      // Email columns
      return { minWidth: '200px' };
    } else if (content.match(/^\+?\d[\d\s-]+$/)) {
      // Phone number columns
      return { minWidth: '120px' };
    } else if (content.match(/^\d{4}-\d{2}-\d{2}$/)) {
      // Date columns
      return { minWidth: '100px' };
    }
  }
  // Default column width
  return { minWidth: '150px' };
};
</script>

<style scoped>
.table-container {
  margin: 16px 0;
  overflow-x: auto;
  background: var(--white-opacity-4);
  border-radius: 8px;
  border: 1px solid var(--white-opacity-8);
}

.custom-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
  color: var(--foreground-rgb);
}

.table-header {
  padding: 12px 16px;
  text-align: left;
  font-weight: 500;
  border-bottom: 1px solid var(--white-opacity-8);
  background: var(--white-opacity-8);
  color: var(--foreground-rgb);
  white-space: nowrap;
}

.table-cell {
  padding: 8px 16px;
  border-bottom: 1px solid var(--white-opacity-8);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.table-row:hover {
  background: var(--white-opacity-4);
}

@media (max-width: 768px) {
  .table-container {
    margin: 12px 0;
  }

  .custom-table {
    font-size: 11px;
  }

  .table-header,
  .table-cell {
    padding: 8px 12px;
  }
}
</style>